import {WorkerDayPanel} from '../employee/worker-day-panel';
import {DatePipe} from '@angular/common';
import {duration} from './workforce-format';
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, HostListener, effect, inject, input, signal} from '@angular/core';
import {RouterLink} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {addDays, format} from 'date-fns';
import {WorkforceService} from './workforce.service';
import {PlanningPanelComponent} from './planning-panel.component';
@Component({selector:'app-employee-workforce', imports:[WorkerDayPanel, DatePipe, TranslatePipe, FormsModule, RouterLink, PlanningPanelComponent], templateUrl:'./employee-workforce.component.html', styleUrl:'./employee-workforce.component.scss'})
export class EmployeeWorkforceComponent{
 openedDay = signal('');
 duration = duration;
 employee = input.required<string>();mode = input('plan');private api = inject(WorkforceService);
 start = format(new Date(), 'yyyy-MM-dd');end = format(addDays(new Date(), 27), 'yyyy-MM-dd');
 shifts = signal<any[]>([]);absences = signal<any[]>([]);days = signal<any[]>([]);sites = signal<any[]>([]);selected = signal<any>(null);
  selectedAbsence = signal<any>(null);error = signal(false);private generation = 0;
 constructor(){
effect(()=>{
this.employee();this.mode();void this.load();
});
}

 @HostListener('window:focus') refreshOnFocus(){
void this.load();
}

 async load(){
const generation = ++this.generation;const employee = this.employee();this.error.set(false);try {
   if (this.mode() === 'plan'){
const [shifts, absences, options] = await Promise.all([this.api.request<any[]>(`shifts?start=${this.start}&end=${this.end}`), this.api.request<any[]>(`absences?start=${this.start}&end=${this.end}`), this.api.request<any>('options?scope=filters')]);if (generation !== this.generation) {
return;
} this.shifts.set(shifts.filter(r=>r.firestore_user_id === employee));this.absences.set(absences.filter(r=>r.firestore_user_id === employee));this.sites.set(options.sites);
} else {
const [days, options] = await Promise.all([this.api.request<any[]>(`work-days?start=${this.start}&end=${this.end}`), this.api.request<any>('options?scope=filters')]);if (generation === this.generation) {
this.sites.set(options.sites);
this.days.set(days.filter(d=>d.firestore_user_id === employee));
}
}
 } catch {
if (generation === this.generation) {
this.error.set(true);
}
}
}

 saved(){
this.selected.set(null);this.selectedAbsence.set(null);void this.load();
}

 siteName(id: string){
return this.sites().find(s=>s.id === id)?.name || id;
}

 minutes(day: any){
return day.segments.reduce((sum: number, s: any)=>sum + s.minutes, 0);
}
}
